export const cosImgUrl = "http://cimg.xiaoheitech.cn";

export const round = (n, decimals = 0) =>
  Number(`${Math.round(`${n}e${decimals}`)}e-${decimals}`);

export const isAndroid = () => {
  let userAgent = navigator.userAgent;
  return userAgent.match(/app_szxc/);
};
export const  datetime=(value, format)=> {
  let item = new Date(value);
  let year = item.getFullYear();
  let month = item.getMonth()+1;
  month=month>0&&month<=9?'0'+month:month
  let day = item.getDate();
  day=day>0&&day<=9?'0'+day:day
  let h = item.getHours();
  h=h>=0&&h<=9?'0'+h:h;
  let m = item.getMinutes();
  m=m>=0&&m<=9?'0'+m:m;
  let s = item.getSeconds();
  s=s>=0&&s<=9?'0'+s:s;
  if(format==1){
    return year+'-'+month+'-'+day
  }else if(format==2) {
    return year+'年'+month+'月'+day+'日'
  }else if(format==3) {
    return year+'.'+month+'.'+day+' '+h+':'+m
  }else if(format==4) {
    return h+':'+m
  }else if(format==5) {
    return year+'-'+month+'-'+day+' '+h+':'+m
  }else if(format==6) {
    return h+':'+m
  }else if(format==7) {
    return year+'年'+month+'月'+day+'日'+' '+h+':'+m
  }else {//默认返回到时分秒
    return year+'-'+month+'-'+day+' '+h+':'+m+':'+s
  }
}
export const isWeiXin = () => {
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};

export const replaceAll = (oldVal, newVal) => {
  return "".replace(new RegExp(oldVal, "g"), newVal);
};

export const shareWeXin = (
  url = location.href,
  title = "数字乡村",
  content = "美丽乡村、生态旅游、农家住宿、乡村信息数字化一站式服务",
  img = "https://cimg.xiaoheitech.cn/static/share.png",
  callback
) => {
  if (isWeiXin()) {
    window.getShareInfoSub(url, title, content, img, callback);
  }
};

export const ismimi = () => {
  let userAgent = navigator.userAgent;
  // let userAgent = 'Mozilla/5.0 (Linux; Android 9; ELE-AL00 Build/HUAWEIELE-AL00; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/67.0.3396.87 XWEB/1166 MMWEBSDK/191201 Mobile Safari/537.36 MMWEBID/8156 MicroMessenger/7.0.10.1580(0x27000A5D) Process/appbrand3 NetType/WIFI Language/zh_CN ABI/arm64 miniProgram'
  //  console.log(userAgent)
  let isminiapp = userAgent.match(/miniProgram/);
  // console.log(isminiapp)
  return isminiapp;
};

export const shareXiaoChengXu = (locationUrl, title, content, img) => {
  let baseUrl =
    process.env.NODE_ENV == "development" ||
    location.host == "gzszxctest.xiaoheitech.cn"
      ? `https://gzszxctest.xiaoheitech.cn/digital_village_apph5/`
      : `https://gzszxc.xiaoheitech.cn/digital_village_apph5/`;
  let tmpUrl = baseUrl + locationUrl;
  let link = decodeURIComponent(tmpUrl);
  let url = "pages/webviews/main?url=" + tmpUrl;
  jsMessage.shareMethod(link, title, content, img, 1, baseUrl, url);
};

export const shareHuoXiaoChengXu = (locationUrl, title, content, img) => {
  let baseUrl =
    process.env.NODE_ENV == "development" ||
    location.host == "gzszxctest.xiaoheitech.cn"
      ? `https://gzszxctest.xiaoheitech.cn/digital_village_apph5/`
      : `https://gzszxc.xiaoheitech.cn/digital_village_apph5/`;
  let tmpUrl = baseUrl + locationUrl;
  let link = decodeURIComponent(tmpUrl);
  let url = "pages/webviews/main?url=" + tmpUrl;
  console.log("aa");
  jsMessage.shareMethodOther(link, title, content, img, 1, baseUrl, url);
};

export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};
export const inputFocus = () => {
  document.getElementsByClassName("van-field__control")[0].onfocus = () => {
    document.getElementsByClassName("van-field__control")[0].blur();
    let dom = document.getElementsByClassName("seach_prop")[0];
    dom.getElementsByClassName("van-field__control")[0].focus();
  };
};
export const hasLogin = () => {
  var ua = navigator.userAgent.toLowerCase();
  console.log("1111", ua);
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        let url = location.href;
        if (url.includes("token")) {
          url = removeURLParameter(url, "token");
          console.log(url);
        }
        // Dialog.confirm({
        //     title: '提示',
        //     message:
        //         '您还没有登录或登录已超时，请重新登录！',
        // }).then(() => {
        //     wx.miniProgram.redirectTo({
        //         url: "../login/index?callback=" + encodeURIComponent(url)
        //     });
        // })
        //     .catch(() => {
        //         wx.miniProgram.switchTab({
        //             url: "../index/index"
        //         });
        //     });

        wx.miniProgram.redirectTo({
          url: "../login/index?callback=" + encodeURIComponent(url),
        });
      }
    });
  }
};
